const MenuSpy = require('menuspy');

$('.toc').each(function () {
    const spy = new MenuSpy(this, {
        threshold: $('.site-header').height() + $(this).height()
    });
});
